import { utils } from '../../utils/index.js';
import { callbackIdFactory } from '../callback-factory.js';
import { type WebviewJavascriptBridgeApi } from '../type.api.js';
import { type CallNtvData, type FabricCallbackData } from '../type.builtin.js';

const { parse, log } = utils;
const callbackIndexes = callbackIdFactory('ios');

export const call: WebviewJavascriptBridgeApi['call'] = <
  TMethod extends string,
>(
  method: TMethod,
  options?: CallNtvData | Function,
  callback?: Function | string
): FabricCallbackData => {
  if (typeof options === 'function') {
    callback = options;
    options = {};
  }
  const callArgs = { _data: options === undefined ? null : options };
  // Notes,注意IOS的callback回调函数的清理, 是靠ios内部bridge实现自己完成的
  // 所有callback函数需要挂载到`window`对象上. 比如例子中`.call("callProgress")`
  // Native会不断回调Web的callback函数,直到native自己认为任务完成, 会自己清理调内存, delete `callback函数`
  let callbackId = '';
  if (typeof callback === 'string') {
    callbackId = callback;
  } else if (typeof callback === 'function') {
    callbackId = callbackIndexes();
    window[callbackId] = function (...args) {
      log.logData(
        `[iOS] WebCallNtv, 接收到Ntv(${method})异步返回数据内容:`,
        ...args
      );
      (callback as Function).call(window, ...args);
    };
  }

  if (callbackId) {
    callArgs['_dscbstub'] = callbackId;
  }

  let ret = '';
  try {
    // if in webview that dsBridge provided, call!
    if (window['_dswk'] || navigator.userAgent.indexOf('_dsbridge') != -1) {
      log.logData(`[iOS] WebCallNtv(${method}), Web输入参数:`, callArgs);
      ret = prompt('_dsbridge=' + method, JSON.stringify(callArgs)) as string;
      log.logData(`[iOS] WebCallNtv(${method}), 同步返回数据内容串:`, ret);
    } else {
      throw new Error('No fabric bridge support!');
    }
    return parse.jsonParse<FabricCallbackData>(ret || '{"code":"0","data":{}}');
  } catch (err: any) {
    log.logError(
      '[iOS] WebViewJavascriptBridge: WARNING: javascript call() handler threw.',
      err
    );
    const errData = {
      code: 'fabric_catched_error',
      data: null,
      message: err?.message,
    };
    if (callbackId) {
      window[callbackId](errData);
    }
    return errData;
  }
};
